import { createFileRoute } from "@tanstack/react-router"
import NotFoundPage from "~/components/NotFoundPage"

function Custom404() {
  return <NotFoundPage />
}

export const Route = createFileRoute("/404")({
  component: Custom404,
})
